import { render, staticRenderFns } from "./StudentClasses.vue?vue&type=template&id=76fe7bb7&"
import script from "./StudentClasses.vue?vue&type=script&lang=js&"
export * from "./StudentClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports